import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'mentionHighlight',
  standalone: true,
  pure: true,
})
export class MentionHighlightPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) { }

  transform(value: string | null | undefined): SafeHtml {
    if (!value) return '';

    const escaped = value
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/\n/g, '<br>');

    const highlighted = escaped.replace(
      /@((?:\w+\.)*\w+)/g,
      '<span class="mention-highlight" data-username="$1" style="cursor:pointer;">@$1</span>',
    );

    return this.sanitizer.bypassSecurityTrustHtml(highlighted);
  }
}
